import React, { useEffect, useState } from 'react';
import { Grid, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { getCities, getDistricts, getZipcode } from '../data/taiwanAddressData';

const TaiwanAddressSelector = ({
  city,
  district,
  zipcode,
  address,
  onCityChange,
  onDistrictChange,
  onZipcodeChange,
  onAddressChange,
  required = false,
  disabled = false,
}) => {
  const [cities] = useState(getCities());
  const [districts, setDistricts] = useState([]);

  useEffect(() => {
    if (city) {
      const list = getDistricts(city);
      setDistricts(list);
      if (district && !list.includes(district)) {
        onDistrictChange('');
        onZipcodeChange('');
      }
      return;
    }
    setDistricts([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [city]);

  useEffect(() => {
    if (city && district) {
      const z = getZipcode(city, district);
      if (z && z !== zipcode) onZipcodeChange(z);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [city, district]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <FormControl fullWidth required={required} disabled={disabled}>
          <InputLabel>縣市</InputLabel>
          <Select
            value={city || ''}
            label="縣市"
            data-testid="address-city"
            onChange={(e) => {
              const v = e.target.value;
              onCityChange(v);
              onDistrictChange('');
              onZipcodeChange('');
            }}
            MenuProps={{ PaperProps: { style: { maxHeight: 320 } } }}
          >
            <MenuItem value="">
              <em>請選擇縣市</em>
            </MenuItem>
            {cities.map((c) => (
              <MenuItem key={c} value={c}>
                {c}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={4}>
        <FormControl fullWidth required={required} disabled={disabled || !city}>
          <InputLabel>區域</InputLabel>
          <Select
            value={district || ''}
            label="區域"
            data-testid="address-district"
            onChange={(e) => {
              const v = e.target.value;
              onDistrictChange(v);
              if (city && v) onZipcodeChange(getZipcode(city, v));
            }}
            MenuProps={{ PaperProps: { style: { maxHeight: 320 } } }}
          >
            <MenuItem value="">
              <em>請選擇區域</em>
            </MenuItem>
            {districts.map((d) => (
              <MenuItem key={d} value={d}>
                {d}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="郵遞區號"
          value={zipcode || ''}
          onChange={(e) => onZipcodeChange(e.target.value)}
          disabled={disabled}
          inputProps={{ 'data-testid': 'address-zipcode' }}
          InputProps={{
            readOnly: !!(city && district),
            sx: city && district ? { bgcolor: 'background.default' } : undefined,
          }}
          helperText={city && district ? '已自動帶入' : ''}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          required={required}
          disabled={disabled}
          label="詳細地址"
          value={address || ''}
          onChange={(e) => onAddressChange(e.target.value)}
          placeholder="例：中山路一段 123 號 5 樓"
          inputProps={{ 'data-testid': 'address-line' }}
        />
      </Grid>
    </Grid>
  );
};

export default TaiwanAddressSelector;
